// <ion-app> starts Ionic's document-wide services (the tap ripple, keyboard
// focus rings, the Android back button, keyboard assist) every time one
// loads, and never stops them. Each /app and /admin page renders its own
// IonApp, so every navigation added another set: a few pages in, one tap
// drew several stacked ripples (a dark navy wash on everything) and a back
// press could be handled more than once. The services listen on the whole
// document, so the first <ion-app> starting them is enough; later ones share
// its keyboard-focus helper (overlays reach it through ion-app's setFocus).
import { IonApp as IonAppElement, defineCustomElement } from "@ionic/core/components/ion-app.js";

let first = null;

export function startIonicServicesOnce() {
  defineCustomElement();
  const proto = IonAppElement.prototype;
  const original = proto.componentDidLoad;
  if (typeof original !== "function" || proto.__startsOnce) return;
  proto.__startsOnce = true;
  proto.componentDidLoad = function componentDidLoadOnce() {
    if (!first) {
      first = this;
      return original.call(this);
    }
    Object.defineProperty(this, "focusVisible", { configurable: true, get: () => first.focusVisible });
    return undefined;
  };
}
